import * as Application from "expo-application";
import * as Device from "expo-device";

import {
  ANDROID_BUNDLE_IDENTIFIERS,
  IOS_BUNDLE_IDENTIFIERS,
} from "./identifiers";

import type { Theme } from "@/screens/Authentication/Components/ProfileGrid/profileThemes";

// Note; changing these values will require changing the values on expo.
export enum AppVariant {
  PRODUCTION = "production",
  PREVIEW = "preview",
  DEVELOPMENT = "development",
  SIMULATOR = "simulator",
  UNKNOWN = "unknown",
}

export function isPublicVariant(): boolean {
  return getAppVariant() === AppVariant.PRODUCTION;
}

/**
 * Marketing mode configuration
 * - MARKETING_MODE_ENABLED: toggles mock data on/off
 * - MARKETING_THEME: controls which theme is used for both the landing
 *   screen (ProfileGrid) and the recommendation feed
 */
const MARKETING_MODE_ENABLED = false;
export const MARKETING_THEME: Theme = "01-asian-theme";

export function isMarketingMode(): boolean {
  return MARKETING_MODE_ENABLED;
}

export function getAppVariant(): AppVariant {
  const bundleId = Application.applicationId || "Unknown";

  if (!Device.isDevice) {
    return AppVariant.SIMULATOR;
  }

  switch (bundleId) {
    case IOS_BUNDLE_IDENTIFIERS.public:
      return AppVariant.PRODUCTION;
    case ANDROID_BUNDLE_IDENTIFIERS.public:
      return AppVariant.PRODUCTION;
    case IOS_BUNDLE_IDENTIFIERS.preview:
      return AppVariant.PREVIEW;
    case ANDROID_BUNDLE_IDENTIFIERS.preview:
      return AppVariant.PREVIEW;
    case IOS_BUNDLE_IDENTIFIERS.development:
      return AppVariant.DEVELOPMENT;
    case ANDROID_BUNDLE_IDENTIFIERS.development:
      return AppVariant.DEVELOPMENT;
    default:
      return AppVariant.UNKNOWN;
  }
}
